<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { Modal } from 'carbon-components-svelte';

  import VenueForm from './VenueForm.svelte';

  import type { MarketVenueRow } from '../../../services';

  export let open = false,
    data: MarketVenueRow | null = null;

  const dispatch = createEventDispatcher<{ close: { action: 'edit-venue' | 'add-venue'; data?: MarketVenueRow } }>();

  let formSubmitButtonRef: HTMLButtonElement,
    loading = false;

  function onModalSubmit() {
    if (!formSubmitButtonRef) {
      throw new Error('Form submit button not found!');
    }

    formSubmitButtonRef.click();
  }

  function onModalClose() {
    dispatch('close');
  }

  $: initialValues = {
    ...(data?.id ? { venueId: data.id } : {}),
    countryCode: data?.countryCode ?? '',
    exchangeName: data?.exchangeName ?? '',
    mic: data?.mic ?? '',
    timezone: data?.timezone ?? '',
  };
</script>

<Modal
  bind:open
  modalHeading={`${data?.id ? 'Edit' : 'Add'} Venue`}
  preventCloseOnClickOutside
  primaryButtonText={data?.id ? 'Save' : 'Add'}
  primaryButtonDisabled={loading}
  secondaryButtonText="Cancel"
  shouldSubmitOnEnter={false}
  on:close={onModalClose}
  on:click:button--secondary={onModalClose}
  on:submit={onModalSubmit}
>
  <VenueForm bind:formSubmitButtonRef bind:loading {initialValues} on:close />
</Modal>
